// This require will be replaced with `@sentry/browser` client side thanks to the webpack config in next.config.js
import { development } from '~/lib/helpers/environment'
const Sentry = require('@sentry/node')

module.exports = () => {
  const sentryOptions = {
    dsn: process.env.SENTRY_DSN,
    ignoreErrors: [
      // Custom
      'status code 401',
      // https://gist.github.com/impressiver/5092952
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      'Can\'t find variable: ZiteReader',
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      'fb_xd_fragment',
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      'conduitPage'
    ],
    denyUrls: [
      /graph\.facebook\.com/i,
      /connect\.facebook\.net\/en_US\/all\.js/i,
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      /extensions\//i,
      /^chrome:\/\//i,
      /127\.0\.0\.1:4001\/isrunning/i,
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
    ],
    maxBreadcrumbs: 50,
    attachStacktrace: true,
    environment: process.env.CI_COMMIT_REF_NAME || 'development',
    release: process.env.CI_COMMIT_SHA || 'development'
  }

  Sentry.init(sentryOptions)

  return {
    Sentry,
    captureException: (error, ctx, profile) => {
      Sentry.configureScope(scope => {
        if (error.message) {
          // Force deduplication by error message if it is present
          scope.setFingerprint([error.message])
        }

        if (error.statusCode) {
          scope.setExtra('statusCode', error.statusCode)
        }

        if (ctx) {
          const { req, res, errorInfo, query, pathname } = ctx

          if (res && res.statusCode) {
            scope.setExtra('statusCode', res.statusCode)
          }

          if (typeof window !== 'undefined') {
            scope.setTag('ssr', false)
            scope.setExtra('query', query)
            scope.setExtra('pathname', pathname)
          } else {
            scope.setTag('ssr', true)
            scope.setExtra('url', req.url)
            scope.setExtra('method', req.method)
            scope.setExtra('headers', req.headers)
            scope.setExtra('params', req.params)
            scope.setExtra('query', req.query)

            // On server-side we take session cookie directly from request
            if (req.cookies && req.cookies.sid) {
              scope.setUser({ id: req.cookies.sid })
            }
          }

          if (errorInfo) {
            Object.keys(errorInfo).forEach(key =>
              scope.setExtra(key, errorInfo[key])
            )
          }
        }

        if (profile && profile.user && profile.user.globalId) {
          scope.setTag('global_id', profile.user.globalId)
        }
      })

      // Rethrow error in development to see full error
      if (development) {
        throw error
      }

      return Sentry.captureException(error)
    }
  }
}
